<template lang="pug">
  main-right(title="修改密码")
    SwitchTab(:arr-items="arrItems" v-model="tabType")
      .login_pwd_form(v-show="tabType == 1")
        LoginInput(
          type="password"
          placeholder="旧密码"
          suffix-icon="iconfont icon-biaodan-tianxie"
          v-model="pwdForm.oldPassword"
        )
        LoginInput(
          type="password"
          placeholder="新密码"
          suffix-icon="iconfont icon-biaodan-tianxie"
          v-model="pwdForm.password"
          tip="8-20位，需包含大小写字母和数字"
        )
        LoginInput(
          type="password"
          placeholder="确认新密码"
          suffix-icon="iconfont icon-biaodan-tianxie"
          v-model="pwdForm.confirmPassword"
          tip="需和上述新密码保持一致"
        )
        ad-button.sure_btn(@click="modifyLoginPasswrord" :disabled="btnDisabled") 完成
      .login_pay_form(v-show="tabType == 2")
        CommonForm(
          baseForm
          :formType="5"
          phonePlaceholder="当前绑定手机号"
          v-model="payPwdForm"
          :disabledPhone="true"
        )
        LoginInput(
          type="password"
          placeholder="新密码"
          v-model="payPwdForm.payPassword"
          tip="请输入6位密码，仅数字"
        )
        LoginInput(
          type="password"
          placeholder="确认新密码"
          tip="需和上述新密码保持一致"
          v-model="payPwdForm.confirmPassword"
        )
        ad-button.sure_btn(@click="modifyPayPassword" :disabled="payBtnDisabled") 完成
</template>

<script>
import SwitchTab from './component/AccountTab'
import LoginInput from '@/components/LoginInput'
import CommonForm from '@/views/Registry/childrens/LoginForm'
import { passwordReg, payPasswordReg, phoneReg } from '@/utils/fn'
import { modifyLoginPwd, modifyPayPwd } from '@/utils/customerApi'

export default {
    name: 'ModifyPassword',
    components: { SwitchTab, LoginInput, CommonForm },
    data () {
      return {
        arrItems: [{ label: '登录密码', value: 1 }, { label: '支付密码', value: 2 }],
        pwdForm: {
          oldPassword: '',
          password: '',
          confirmPassword: ''
        },
        payPwdForm: {
          phoneNumber: '',
          smsVerifyCode: '',
          payPassword: '',
          confirmPassword: ''
        },
        tabType: this.$route.query.type ? this.$route.query.type - 0 : 1,
        btnDisabled: true,
        payBtnDisabled: true
      }
    },
    watch: {
      pwdForm: {
        deep: true,
        handler (nv) {
          let mark = true
          for (let key in nv) {
            mark = !!nv[key] && mark
          }
          this.btnDisabled = !mark
        }
      },
      payPwdForm: {
        deep: true,
        handler (nv) {
          let mark = true
          for (let key in nv) {
              mark = !!nv[key] && mark
          }
          this.payBtnDisabled = !mark
        }
      }
    },
    methods: {
      async modifyLoginPasswrord () {
        let { oldPassword, password, confirmPassword } = this.pwdForm
        if (!oldPassword) return this.messageTip('请输入旧密码')
        if (!passwordReg.test(password.trim())) return this.messageTip('请输入8~20位含有大小写字母和数字的密码')
        if (confirmPassword.trim() !== password.trim()) return this.messageTip('请再次输入相同的新密码')
        let opt = await this.encryptorProto({ oldPassword, password, confirmPassword })
        if (opt) {
          let res = await modifyLoginPwd(opt)
          let _vm = this
          if (res && res.code === 0) {
            this.$message({
              type: 'success',
              duration: 2000,
              message: '密码修改成功，请重新登录',
              onClose (msg) {
                _vm.goLogin()
              }
            })
            tzx_czcPush('account', 'changeLoginPwdSuccess')
          } else tzx_czcPush('account', 'changeLoginPwdFail')
        }
      },
      async modifyPayPassword () {
        let { phoneNumber, smsVerifyCode, payPassword, confirmPassword } = this.payPwdForm
        if (!phoneReg.test(phoneNumber)) return this.$message.error('请输入正确的手机号')
        if (!payPasswordReg.test(payPassword.trim())) return this.$message.error('请输入6位数字支付密码')
        if (confirmPassword.trim() !== payPassword.trim()) return this.messageTip('请再次输入相同的支付密码')

        let opt = await this.encryptorProto({ password: payPassword, confirmPassword })
        if (opt) {
          opt.phoneNumber = phoneNumber
          opt.smsVerifyCode = this.encode(smsVerifyCode)
          const res = await modifyPayPwd(opt)
          if (res && res.code === 0) {
            this.$store.dispatch('customer/getUserInfo') // 更新用户数据

            const qry = this.$route.query
            const tipStr = res.message || (qry.payRedirect ? '支付密码设置成功' : '支付密码修改成功')
            this.messageTip(tipStr, 1)
            const tt = setTimeout(() => {
              clearTimeout(tt)
              if (qry.payRedirect) {
                this.messageTip('跳转去支付~', 1)
                this.goUrl(qry.payRedirect, { id: qry.orderId })
              } else {
                const to = setTimeout(() => {
                  clearTimeout(to)
                  this.goUrl('/home')
                }, 500)
              }
            }, 1500)
            tzx_czcPush('account', 'changePayPwdSuccess')
          } else {
            tzx_czcPush('account', 'changePayPwdFail')
          }
        }
      }
    }
}
</script>

<style lang="sass" scoped>
.login_pwd_form, .login_pay_form
  width: 360px
  margin: 60px auto
.sure_btn
  margin-top: 60px !important
.input_container
  margin-top: 20px
  margin-bottom: 30px
</style>